import request from './http'

// 登录
export function login(data) {
    return request({
        url: '/api/login',
        method: 'post',
        data
    })
}
// 获取所有设备
export function devices(data) {
    return request({
        url: '/api/devices',
        method: 'get',
        data
    })
}
// 获取所有工单
export function alltickets(data) {
    return request({
        url: '/api/alltickets',
        method: 'get',
        data
    })
}

// 更新工单
export function updateticket(ticket_id, data) {
    return request({
        url: `/api/updateticket/${ticket_id}`,
        method: 'post',
        data
    })
}
export function devices_code(devices_code) {
    return request({
        url: `/api/v1/devices/${devices_code}`,
        method: 'get',
    })
}
// 添加楼层 总楼层修改
export function content(devices_code, data) {
    return request({
        url: `/api/v1/devices/${devices_code}/content`,
        method: 'post',
        data
    })
}
// 修改楼层
export function setfloors(devices_code, floor_name, data) {
    return request({
        url: `/api/v1/devices/${devices_code}/content/floors/${floor_name}`,
        method: 'post',
        data
    })
}
// 修改类型
export function page_type(devices_code, data) {
    return request({
        url: `/api/v1/devices/${devices_code}/page_type`,
        method: 'post',
        data
    })
}